<template>
  <div style="background: #000;height: 100vh" v-if="!loading">

    <div style="width: 100%; height: 100% ; position: relative">
      <div class="score-head">
        <div class="score-logo" style="position: absolute; top: 20px;left: 50px">
          <div class="score-logo-box" style="padding:2px;background: #fff;border-radius: 100%;">
            <img src="../../assets/logo.png" alt="" style="width: 60px;height: 60px;border-radius: 100%;">
          </div>
        </div>

        <div class="score-menu" style="position: absolute; top: 20px;right: 50px">
          <div class="score-menu-box">
            <a-icon type="menu" @click="drawerVisible = true" :style="{ fontSize: '26px'}"/>
          </div>
        </div>
        <div style="font-size: 26px;padding: 30px 0 45px">
          {{ apply.danwei }}{{ apply.datetitle }}考级
          <br/> 
          <a-radio-group v-model="exameYearType" style="margin-top: 10px">
            <a-radio-button :value="1">
              2019周期
            </a-radio-button>
            <a-radio-button :value="2">
              2022周期
            </a-radio-button> 
          </a-radio-group>
        </div>

          

      </div>

          <div class="score-content-name flex-start">
            <div @click="changeMember(index)" :key="index" :class="index == currentMemberIndex ? 'score-name-li score-name-li-active': 'score-name-li'" v-for="(item, index) in list2[currentIndex]">
              {{item.name}}
            </div>
          </div>
      <div class="score-content flex-start">


        <div class="score-content-left">
          <div class="score-content-operate">
            <div class="score-li"  >
              <div class="score-li-box">
                <div class="score-li-kaoguan-li">
                  <div  v-show="memberRow.status==1" :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki+'t'"  v-for="(kv,ki) in kaoguan" @click="onScoreOperate('score_fanteng'+(ki+1))">
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_fanteng'+(ki+1)]}}</em>
                    <a-icon type="edit" />
                  </div> 
                   <div  v-show="memberRow.status!=1" :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki"  v-for="(kv,ki) in kaoguan" >
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_fanteng'+(ki+1)]}}</em> 
                  </div>
                </div>
                <div class="score-li-kaoguan-score"> 
                    <p>翻腾</p>
                    <span>实际得分</span>
                    <em>{{memberRow.score_fanteng/10}}</em>  
                </div> 
              </div> 
            </div>

            <div class="score-li"  >
              <div class="score-li-box">
                <div class="score-li-kaoguan-li">
                  <div v-show="memberRow.status==1" :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki+'t'"  v-for="(kv,ki) in kaoguan" @click="onScoreOperate('score_zhuanti'+(ki+1))">
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_zhuanti'+(ki+1)]}}</em> 
                    <a-icon type="edit" />
                  </div> 
                  <div v-show="memberRow.status!=1" :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki"  v-for="(kv,ki) in kaoguan" >
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_zhuanti'+(ki+1)]}}</em>  
                  </div> 
                </div>
                <div class="score-li-kaoguan-score"> 
                    <p>转体</p>
                    <span>实际得分</span>
                    <em>{{memberRow.score_zhuanti/10}}</em>  
                </div> 
              </div> 
            </div>

            <div class="score-li"  >
              <div class="score-li-box">
                <div class="score-li-kaoguan-li">
                  <div v-show="memberRow.status==1" :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki+'t'"  v-for="(kv,ki) in kaoguan" @click="onScoreOperate('score_tiaoyue'+(ki+1))">
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_tiaoyue'+(ki+1)]}}</em>
                    <a-icon type="edit" />
                  </div> 
                  <div v-show="memberRow.status!=1" :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki"  v-for="(kv,ki) in kaoguan">
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_tiaoyue'+(ki+1)]}}</em> 
                  </div> 
                </div>
                <div class="score-li-kaoguan-score"> 
                    <p>跳跃</p>
                    <span>实际得分</span>
                    <em>{{memberRow.score_tiaoyue/10}}</em>  
                </div> 
              </div> 
            </div>


            <div class="score-li"  >
              <div class="score-li-box">
                <div class="score-li-kaoguan-li">
                  <div v-show="memberRow.status==1"  :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki+'t'"  v-for="(kv,ki) in kaoguan" @click="onScoreOperate('score_pingheng'+(ki+1))">
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_pingheng'+(ki+1)]}}</em>
                    <a-icon type="edit" />
                  </div> 
                  <div v-show="memberRow.status!=1"  :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki"  v-for="(kv,ki) in kaoguan" >
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_pingheng'+(ki+1)]}}</em> 
                  </div> 
                </div>
                <div class="score-li-kaoguan-score"> 
                    <p>平衡柔韧</p>
                    <span>实际得分</span>
                    <em>{{memberRow.score_pingheng/10}}</em>  
                </div> 
              </div> 
            </div>

            <div class="score-li"  >
              <div class="score-li-box">
                <div class="score-li-kaoguan-li">
                  <div v-show="memberRow.status==1"  :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki+'t'"  v-for="(kv,ki) in kaoguan" @click="onScoreOperate('score_liliang'+(ki+1))">
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_liliang'+(ki+1)]}}</em>
                    <a-icon type="edit" />
                  </div> 
                  <div v-show="memberRow.status!=1"  :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki"  v-for="(kv,ki) in kaoguan">
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_liliang'+(ki+1)]}}</em> 
                  </div> 
                </div>
                <div class="score-li-kaoguan-score"> 
                    <p>力量素质</p>
                    <span>实际得分</span>
                    <em>{{memberRow.score_liliang/10}}</em>  
                </div> 
              </div> 
            </div>


            <div class="score-li"  >
              <div class="score-li-box">
                <div class="score-li-kaoguan-li">
                  <div v-show="memberRow.status==1"  :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki+'t'"  v-for="(kv,ki) in kaoguan" @click="onScoreOperate('score_dongzuo'+(ki+1))">
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_dongzuo'+(ki+1)]}}</em>
                    <a-icon type="edit" />
                  </div> 
                  <div v-show="memberRow.status!=1"  :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki"  v-for="(kv,ki) in kaoguan">
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_dongzuo'+(ki+1)]}}</em> 
                  </div> 
                </div>
                <div class="score-li-kaoguan-score"> 
                    <p>动作组合</p>
                    <span>实际得分</span>
                    <em>{{memberRow.score_dongzuo/10}}</em>  
                </div> 
              </div> 
            </div>


            <div class="score-li" v-show="exameYearType==2" >
              <div class="score-li-box">
                <div class="score-li-kaoguan-li">
                  <div v-show="memberRow.status==1"  :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki+'t'"  v-for="(kv,ki) in kaoguan" @click="onScoreOperate('score_sudu'+(ki+1))">
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_sudu'+(ki+1)]}}</em>
                    <a-icon type="edit" />
                  </div> 
                  <div v-show="memberRow.status!=1"  :style="{'height':(160/kaoguan.length)+'px','line-height':(160/kaoguan.length)+'px',}" :key="ki"  v-for="(kv,ki) in kaoguan" >
                    <p>{{kv}}</p>
                    <em>{{memberRow['score_sudu'+(ki+1)]}}</em> 
                  </div> 
                </div>
                <div class="score-li-kaoguan-score"> 
                    <p>速度与灵敏</p>
                    <span>实际得分</span>
                    <em>{{memberRow.score_sudu/10}}</em>  
                </div> 
              </div> 
            </div>


            <div class="score-li" :style="{width:exameYearType==1?'':'22%'}">
              <div class="score-li-box">
                <div v-show="memberRow.status==1"  class="caipan-info" @click="onScoreOperate('score_sai')">
                  <div class="caipan-name">参与赛事</div>

                  <div class="caipan-score">{{ memberRow['score_sai'] }} </div>
                    <a-icon type="edit" /> 
                </div> 
                 <div v-show="memberRow.status!=1"  class="caipan-info"  >
                  <div class="caipan-name">参与赛事</div>

                  <div class="caipan-score">{{ memberRow['score_sai'] }} </div> 
                </div> 
              </div> 
            </div>
            <div class="score-li" :style="{width:exameYearType==1?'':'22%'}">
              <div class="score-li-box">
                <div v-show="memberRow.status==1"  class="caipan-info" @click="onScoreOperate('score_peixun')">
                  <div class="caipan-name">培训课时分</div>

                  <div class="caipan-score">{{ memberRow['score_peixun'] }} </div>
                    <a-icon type="edit" /> 
                </div> 
              </div> 
            </div>
            <div class="score-li" :style="{width:exameYearType==1?'':'22%'}">
              <div v-show="memberRow.status==1"  class="score-li-box">
                <div class="caipan-info" @click="onScoreOperate('score_gongyi')">
                  <div class="caipan-name">品德</div>

                  <div class="caipan-score">{{ memberRow['score_gongyi'] }} </div>
                    <a-icon type="edit" /> 
                </div> 
              </div> 
              <div v-show="memberRow.status!=1"  class="score-li-box">
                <div class="caipan-info" >
                  <div class="caipan-name">品德</div>

                  <div class="caipan-score">{{ memberRow['score_gongyi'] }} </div> 
                </div> 
              </div> 
            </div>

             
          </div>
        </div>
        <div class="score-content-right">
          <div class="content-right-head">
            
            <div>人员信息</div>
            <p>
              <span>运动员</span>
              <em>{{memberRow.name}}</em>
            </p>
            <p>
              <span>身份证</span>
              <em>{{memberRow.num}}</em>
            </p>
            <p>
              <span>星级</span>
              <em>{{memberRow.grade}}</em>
            </p>
            <p>
              <span>考官</span>
              <em><a-tag :key="ki" v-for="(kv,ki) in kaoguan">{{kv}}</a-tag></em>
            </p>
            <p>
              <span>监督</span>
              <em><a-tag :key="ki" v-for="(kv,ki) in jiandu">{{kv.name}}</a-tag></em>
            </p>
          </div>

          <div class="content-right-body">
            <div class="right-body-top flex-between">
              <div>最终分数</div> 

              <a-button type="primary" v-if="memberRow.huankao==2" @click="setHuankao"> 设置缓考
              </a-button>
              <a-button  v-else  @click="setHuankao"> 已设置缓考（点击恢复）
              </a-button>

              <a-button type="primary" @click="handleRank">查看分数</a-button>
            </div>

            <div class="right-body-score">
              {{ memberRow.score_total }}
            </div> 

          </div>

          <div class="content-right-foot content-right-foot-start" v-if="memberRow.status>0" >
            <a-popconfirm title="确认提交分数吗?" @confirm="onSubjectStatusChange(2)" okText="确定"
                          cancelText="取消" v-if="memberRow.status == 1">
              <div class="content-right-foot content-right-foot-score">提交分数</div>
            </a-popconfirm>
            <div class="content-right-foot content-right-foot-started" v-else-if="memberRow.status == 2">
              已完成
            </div>
            <div class="content-right-foot" v-else-if="memberRow.status == 3">
              已缓考
            </div>
          </div>

          <div class="content-right-foot" v-else>
            <!-- <div class="content-right-foot-start"  >已弃权</div> -->
            <!-- <div class="content-right-foot content-right-foot-started" v-else-if="subjectRow.status == 2"> -->
              <!-- 已完成 -->
            <!-- </div> -->
            <div class="content-right-foot-un-start" v-if="memberRow.status==0" @click="handleSetCurrent(currentIndex)"  >开始评分</div>
          </div>
        </div>

      </div>
       


      <div class="score-foot">
        <div class="foot-index">{{ parseInt(currentIndex) + 1 }} / {{ list2.length }}</div>
        <div class="foot-content flex-between">
          <img src="../../assets/icon-score-left-disabled.png" v-if="currentIndex === 0" alt="">
          <img src="../../assets/icon-score-left.png" v-else @click="onSubjectPrev">

          <div class="foot-li-box flex-start">
            <div :style="'width: ' + 100 / list2.length + '%'"
                 v-for="(item, index) in list2" :key="item.id">
              <div v-if="item[0].status == 2" class="foot-li foot-li-active"
                   :class="index == currentIndex ? 'foot-li-selected' : ''">{{ index + 1 }}
              </div>
              <div v-if="item[0].status == 3" class="foot-li foot-li-fail"
                   :class="index == currentIndex ? 'foot-li-selected' : ''">{{ index + 1 }}
              </div>
              <div :class="index == currentIndex ? 'foot-li-selected' : ''" v-if="item[0].status == 1" class="foot-li">
                {{ index + 1 }}
              </div>
            </div>
          </div>
          <img src="../../assets/icon-score-right-disabled.png" v-if="currentIndex === list2.length - 1"
               alt="">
          <img src="../../assets/icon-score-right.png" v-else @click="onSubjectNext" alt="">
        </div>
      </div>

<!--      <div style="color: #fff">subjectRow.status || {{subjectRow}}</div>-->
    </div>

    <a-drawer
        title="出场顺序"
        placement="right"
        width="360"
        :closable="false"
        :visible="drawerVisible"
        :get-container="false"
        :wrap-style="{ position: 'absolute' }"
        @close="drawerVisible = false"
    >
      <div class="army-box">
        <div class="army-li"  v-for="(sublist, index) in list2"
             :key="index" @click="changeCurrent(index)">
          <div class="army-li-left">
            <div :key="mk" v-for="(mv,mk) in sublist" class="army-name">{{mv.name}}({{mv.grade}}) {{mv.score_total}} 分</div> 
          </div>
          <div class="army-li-right" style="margin-left:10px" v-if="currentIndex == index">
            <a-icon type="check-circle" :style="{ fontSize: '22px'}" theme="twoTone" two-tone-color="#52c41a"/>
          </div>
        </div>
      </div>
    </a-drawer>
    <a-modal
        :maskClosable="false"
        title="操作"
        :width="600"
        :centered="true"
        style="z-index:10000"
        v-model="scoreVisible"
        @cancel="scoreVisible = false"
    >
      <a-form :form="form">
        <a-form-item label="打分" :labelCol="labelCol" :wrapperCol="wrapperCol"> 
          <a-input-number  v-model="scoreValue" @change="onScoreValueChange"  :min="0" :max="100"
                          placeholder="请输入分值" style="width: 300px"/>
        </a-form-item>
         

      </a-form>
      <template slot="footer">
        <a-button key="cancel" @click="scoreVisible = false">取消</a-button>
        <a-button key="forward" type="primary" @click="onScoreSave">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
        title="分数信息"
        width="90%"
        :centered="true"
        :footer="null"
        :bodyStyle="{maxHeight:'600px','overflowY':'scroll'}"
        v-model="rankVisible" 
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form"  layout="inline"> 

          <a-table :columns="step2Columns" :dataSource="list2[currentIndex]" :scroll="{x:'100%', y: 600 }" :pagination="false" rowKey="id"
                   bordered>  

         <div slot="score_fanteng" slot-scope="name,record,index">
            <div
                    v-for="(kaoguan,kv) in kaoguan"
                    style="line-height:30px"
                    :key="kv"
                    @click="changeMember(index);onScoreOperate('score_fanteng'+(kv+1))"
            >
               考官{{kv+1}} {{record['score_fanteng'+(kv+1)]}}分 <a-icon type="edit" />
            </div>
              </div>

         <div slot="score_zhuanti" slot-scope="name,record,index">
            <div
                    v-for="(kaoguan,kv) in kaoguan"
                    style="line-height:30px"
                    :key="kv"
                    @click="changeMember(index);onScoreOperate('score_zhuanti'+(kv+1))"
            >
               考官{{kv+1}} {{record['score_zhuanti'+(kv+1)]}}分 <a-icon type="edit" />
            </div>
              </div>

         <div slot="score_tiaoyue" slot-scope="name,record,index">
            <div
                    v-for="(kaoguan,kv) in kaoguan"
                    style="line-height:30px"
                    :key="kv"
                    @click="changeMember(index);onScoreOperate('score_tiaoyue'+(kv+1))"
            >
               考官{{kv+1}} {{record['score_tiaoyue'+(kv+1)]}}分 <a-icon type="edit" />
            </div>
              </div>
 
         <div slot="score_pingheng" slot-scope="name,record,index">
            <div
                    v-for="(kaoguan,kv) in kaoguan"
                    style="line-height:30px"
                    :key="kv"
                    @click="changeMember(index);onScoreOperate('score_pingheng'+(kv+1))"
            >
               考官{{kv+1}} {{record['score_pingheng'+(kv+1)]}}分 <a-icon type="edit" />
            </div>
              </div>
 
         <div slot="score_liliang" slot-scope="name,record,index">
            <div
                    v-for="(kaoguan,kv) in kaoguan"
                    style="line-height:30px"
                    :key="kv"
                    @click="changeMember(index);onScoreOperate('score_liliang'+(kv+1))"
            >
               考官{{kv+1}} {{record['score_liliang'+(kv+1)]}}分 <a-icon type="edit" />
            </div>
              </div>

 
         <div slot="score_dongzuo" slot-scope="name,record,index">
            <div
                    v-for="(kaoguan,kv) in kaoguan"
                    style="line-height:30px"
                    :key="kv"
                    @click="changeMember(index);onScoreOperate('score_dongzuo'+(kv+1))"
            >
               考官{{kv+1}} {{record['score_dongzuo'+(kv+1)]}}分 <a-icon type="edit" />
            </div>
              </div>

 
         <div slot="score_sudu" slot-scope="name,record,index">
            <div
                    v-for="(kaoguan,kv) in kaoguan"
                    style="line-height:30px"
                    :key="kv"
                    @click="changeMember(index);onScoreOperate('score_sudu'+(kv+1))"
            >
               考官{{kv+1}} {{record['score_sudu'+(kv+1)]}}分 <a-icon type="edit" />
            </div>
              </div>

 
         <div slot="score_sai" slot-scope="name,record,index">
            <div 
                    style="line-height:30px" 
                    @click="changeMember(index);onScoreOperate('score_sai')"
            >
                {{record['score_sai']}}分 <a-icon type="edit" />
            </div>
              </div>

         <div slot="score_gongyi" slot-scope="name,record,index">
            <div 
                    style="line-height:30px"
                    :key="index"
                    @click="changeMember(index);onScoreOperate('score_gongyi')"
            >
                {{record['score_gongyi']}}分 <a-icon type="edit" />
            </div>
              </div>

         <div slot="score_peixun" slot-scope="name,record,index">
            <div 
                    style="line-height:30px" 
                    @click="changeMember(index);onScoreOperate('score_peixun')"
            >
                {{record['score_peixun']}}分 <a-icon type="edit" />
            </div>
              </div>
          </a-table>
        </a-form>

      </a-spin> 
    </a-modal>


     

     
  </div>
</template> 
<style>
body {
  overflow-y: hidden;
}

.army-li {
  padding: 10px 0;
  border-bottom: 1px solid #efefef;
  display: flex;
  /* justify-content: center; */
  /* align-items: center; */
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

.score-foot {
  margin: 0px 30px 0;
}

.score-foot img {
  width: 20px;
  cursor: pointer;
}

.foot-index {
  color: #aaa;
  margin-bottom: 10px;
  text-align: center;
}

.foot-li-box {
  width: 92%;
}

.foot-li {
  height: 40px;
  border: 1px solid #4A4A4A;
  text-align: center;
  line-height: 40px;
  color: #666;
  font-size: 16px;
}

.foot-li-active {
  background: #1F85E2;
}

.foot-li-fail {
  background: #FF4D50;
}

.foot-li-selected {
  border: 1px solid #fff;
}

.score-content-right {
  width: 25%;
  background: #333333;
  border-radius: 10px;
  color: #fff;
  overflow: hidden;
  position: relative;
}

.content-right-head {
  padding: 20px 15px 10px;
  border-bottom: 1px dashed #aaa;
  font-size: 16px;
}
.content-right-head div{
  margin-bottom: 10px;
}
.content-right-head p{ 
  margin: 0 ;
  line-height: 30px;
  height: 30px;
}
.content-right-head span{ 
  width: 70px;
  display: inline-block;
  color: #666;

}
.content-right-head em{ 
  font-style: normal;
  color: #fff;
}

.right-head-li {
  width: 50%;
  text-align: center;
}

.right-head-li-disabled {
  color: #666;
}

.content-right-body {
  padding-top: 15px;
}

.right-body-top {
  padding: 0 20px;
}

.right-body-score {
  font-size: 90px;
  padding-left: 15px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
}

.right-body-time {
  padding-left: 20px;
}

.right-body-time-one {
  display: flex;
  align-items: center;
}

.right-head-line {
  width: 1px;
  height: 15px;
  background: #aaa;
}

.right-body-time-rule button {
  margin-left: 10px;
}

.body-time-value {
  font-size: 30px;
  font-family: Helvetica;
  color: #FFFFFF;
}

.time-rule-value {
  font-size: 18px;
  font-family: Helvetica;
  color: #D0021B;
}

.body-time-button {
  margin-top: 5px;
}

.body-time-button button {
  margin-right: 10px;
}

.content-right-foot {
  position: absolute;
  bottom: 0;
  height: 60px;
  line-height: 60px;
  width: 100%;
  text-align: center;
  font-size: 22px;
}

.content-right-foot-un-start {
  background: #1F85E2;
  cursor: pointer;
}

.content-right-foot-started {
  background: #0EB791;
}

.content-right-foot-start {
  background: #4A4A4A;
}

.content-right-foot-score {
  background: #FF4D50;
}

.score-head {
  background: url("../../assets/icon-score-bg.png") no-repeat;
  background-size: 100% 106px;
  height: 205px;
  text-align: center;
  color: #fff;
  font-weight: 500;
}

.score-content {
  margin: 16px 30px 0;
}

.score-content-left {
  width: 75%;
}

.score-content-operate {
  display: flex;
  flex-wrap: wrap;
}

.score-li {
  width: 33%;
  text-align: center;
}

.score-li-box {
  margin: 0 10px 10px 0;
  background: #fff;
  overflow: hidden;
  border-radius: 10px;
}

.caipan-info {
  padding: 0 0 10px 0 ;
  cursor: pointer;
}

.caipan-info-disabled {
  background: #EEEEEE;
}

.caipan-name {
background: #1c85e2;
    height: 40px;
    line-height: 40px;
    font-weight: 500;
    color: #fff;
}

.caipan-score {
  display: inline;
  font-size: 30px;
  font-weight: 500;
  color: #000;
  font-family: DINAlternate-Bold, DINAlternate;
}

.caipan-comment {
  color: #9B9B9B;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caipan-button {
  padding: 0 5px;
  height: 35px;
  width: 100%;
}

.caipan-button-active {
  background: #1F85E2;
}

.caipan-button-score {
  background: #0EB791;
  cursor: pointer;
}

.caipan-button-disabled {
  background: #9B9B9B;
}

.caipan-button-li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  height: 35px;
  cursor: pointer;
  color: #fff;
}

.caipan-score-li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  color: #fff;
  height: 35px;
  cursor: pointer;
}

.caipan-button-li img, .caipan-score-li img {
  width: 14px;
  margin-right: 5px;
}


.score-content-name {
background: #fff; 
    font-weight: 500;
    color: #666666;
    /* padding: 0.2rem 0; */
    height: 60px;
    /* width: 100%; */
    margin: -88px 30px 0;
    line-height: 60px;
    border-radius: 30px;
    /* margin-bottom: 30px; */
}

.score-content-name .score-name-li {
  width: 25%;
  cursor: pointer;
  text-align: center;
  font-size: 18px;
}

.score-content-name .score-name-li-active {
background: #1D85E2;
    -webkit-box-shadow: 0px 1px 7px 0px rgb(74 144 226 / 10%);
    box-shadow: 0px 1px 7px 0px rgb(74 144 226 / 10%);
    font-weight: 500;
    /* height: 0.66rem; */
    border-radius: 30px;
    line-height: 60px;
    color: #F2F7FF;
}
.score-li-kaoguan-li{ 
  float: left;
  width: 50%;
  cursor: pointer;
}
.score-li-kaoguan-li div{
  height: 80px;
  line-height: 80px;
  border: 1px solid #ccc;
  border-bottom:none;
}
 
.score-li-kaoguan-li p{
  display: inline;
  font-size: 12px;
  color: #666; 
}
.score-li-kaoguan-li em{ 
  font-size: 36px;
  margin: 0 10px;
  font-style: normal;
  font-weight: bold;
  color: #000; 
}
.score-li-kaoguan-score{ 
  float: right;
  width: 50%;
}
.score-li-kaoguan-score p{ 
  font-size: 18px;
  height: 48px;
  line-height: 48px;
  font-weight: bold;
  background: #1c85e2; 
  color: #fff;
}
.score-li-kaoguan-score span{
  display: block;
  font-size: 12px;
  color: #666; 
}
.score-li-kaoguan-score em{
  display: block;
  font-size: 36px; 
  font-style: normal;
  font-weight: bold;
  color: #000; 
}
</style>
<script>
import qs from 'qs'
import {
  scoreFormDetail, scoreSimpleSave,setHuankaoStatus,setYearType,setCurrent,setSubjectStatus
} from '@/api/kaojiexame' 
import EditableCell from '@/components/EditableCell/' 
import moment from 'moment'  

export default {
  name: 'ScoreForm',
  components: {
    EditableCell
  },
  data() {
    return {
      loading: true,
      exameYearType:1,
      saveLoading: false,
      drawerVisible: false,
      scoreVisible: false,
      rankVisible: false,
      dataVisible: false, // 修改数据
      currentFilter: false,
      currentCpIndex: 0,
      // tableHeight:document.documentElement.clientHeight-180,
      // tableHeight:300,
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperColNew: {
        xs: {span: 24},
        sm: {span: 12},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      form: this.$form.createForm(this),
      row: {
        current_index: 0,
        caipan_type_num: 1,
        sai_time_total: '00:00:00', //比赛用时
        is_admin: true
      }, 
      list2: [{}],
      commentList: [],
      defaultCaipanList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], //默认裁判数量
      kaoguan: [], 
      jiandu: [], 

      scoreList: [{stime: ''}],
      formData: {
        id: 0
      },
      apply:{

      },

      currentIndex: 0, //当前队伍
      currentMemberIndex: 0, //当前运动员index 

      // 单只项目队伍信息
      subjectRow: {
        id: 0,
        rank: 0,
        score_total: '0.0', // 总得分
        jgroup: '',
        subject_name: 'xx',
        mingcheng: 'xx',
        timeStatus: ''
      },

      isContinue: false,
      timeVisible: false,
      sTime: '00:00:00', //比赛用时字符串
      socket: '',

      status: '', // pause
      timerList: [],
      timeTotal: 0,
      timeString: 0,
      scoreValue: '', //分值
      scoreComment: '', // 减分评语
      scoreCommentId: '', // 减分评语id
      caipanIndex: 0, //操作的裁判

      dataId: 0,
      dataRow: {},

      queryParam: {
        keywords: '',
        showScore: 1, // 只显示有分数的
        subjectRow: '',
        sjsq: [],
      },
 

      // 订正数据表头
      dataColumns: [],

        //表头2
      step2Columns:[], 

      timer: null,
      memberRow:{
        huankao:0
      }
    }

  },
  mounted() {
    const that = this
    let id = that.formData.id = that.$route.query.id

    // 开始socket
    // that.init()

    // 获取数据
    that.fetch()

    // 换成轮询
    that.timer = setInterval(function () {
      that.fetch()
    }, 3000)
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  computed: { 
  },

    watch: { 
      'exameYearType': {
        handler(newValue, oldValue) {
          let that = this;
          setYearType({
            exame_id:that.formData.id,
            year_type:newValue
          })
          this.scoreCompute(); 
          this.columnsCompute();
        },
        deep: true
      },
    },
  methods: {
    moment,
    fetch() {
      //刷新数据
      const that = this

      scoreFormDetail({
        exame_id: that.formData.id
      }).then(res => { 
        that.list2 = res.data.list2  
        that.apply = res.data.apply  
        that.kaoguan = res.data.exame.kaoguan  
        that.exameYearType = res.data.exame.year_type  
        that.jiandu = res.data.apply.jiandu  
        that.loading = false;
        that.scoreCompute();
      }).catch(err => {
        that.$message.error(err.data.msg)
      })
    },
   

    handleEdit(record) {

      console.log("handleEdit", record)
      this.dataRow = record
      this.dataVisible = true
 
      let data = []
      for (var i = 1; i <= 12; i++) {
        let row = {}

        if (i == 11) {
          row.title = '加分'
          row.scopedSlots = {customRender: 'dataCaipanAdd'}
        } else if (i == 12) {
          row.title = '减分'
          row.scopedSlots = {customRender: 'dataCaipanPen'}
        } else {
          row.title = '裁判' + i
          row.scopedSlots = {customRender: 'dataCaipan' + i}
        }

        row.dataIndex = i

        data.push(row)
      }
      console.log(data)
      this.dataColumns = data
    },
 
    
 
    onScoreValueChange(value) {
      console.log("onScoreValueChange", value)
    },

    // 操作分数
    onScoreOperate(score_name) {
      let that = this 
      that.scoreVisible = true

      // console.log("onScoreOperate", index, that.scoreValue)

      that.scoreValue = that.memberRow[score_name];
      that.scoreName = score_name;
      console.log('onScoreOperate') 
    },
 
 
 
    // 存储分数
    onScoreSave() { 

      const that = this

      scoreSimpleSave({
        id: that.memberRow.id,
        score_name: that.scoreName,
        score_value: that.scoreValue,
      }).then(res => { 

      that.scoreVisible = false
        that.fetch();
      }).catch(err => {
        that.$message.error(err.data.msg)
      })

     },

    // 切换下一支队伍
    onSubjectNext() {
      let that = this,
          index = that.currentIndex
      that.currentIndex = parseInt(index) + 1

      // that.getSubjectRow()
    },

    // 切换指定队伍
    onSubjectCurrent(index) {
      let that = this
      that.currentIndex = index

      // that.getSubjectRow()
    },

    // 切换上一支队伍
    onSubjectPrev() {
      let that = this,
          index = that.currentIndex
      that.currentIndex = index - 1

      // that.getSubjectRow()
    },
    submitForm() {
    },


    // 开始比赛
    handleSetCurrent(current_index) {
      const that = this
      setCurrent({ 
        exame_id:that.formData.id,
        current_index: current_index,
        list:JSON.stringify(that.list2[current_index])
      }).then(res => {
        // 通知所有普通裁判
        let data = {
          id: that.formData.id
        }
        // let val = that.formatSocketInfo('sai_start', '', data)
        // this.socket.send(val) 
        // tha
        that.drawerVisible = false
        that.$message.success('开始评分')
        that.currentIndex = current_index

      }).catch(err => {
        that.$message.error(err.data.msg);
      })
    },

    // 
    onSubjectStatusChange(status) {
      let that = this

      setSubjectStatus({
        exame_id: that.formData.id,
        list: JSON.stringify(that.list2[this.currentIndex]),
        status
      }).then(res => {
        that.$message.success('操作成功');

        // 刷新当前状态
        that.fetch()

        // let type = 'score_submit'
        // if (status === 3) type = 'sai_giveup'
        //
        // let data = {
        //   'id': that.row.id
        // }
        // let val = that.formatSocketInfo(type, '', data)
        //
        // that.socket.send(val)
      }).catch(err => {
        console.log('--错误--');
        that.$message.error(err.data.msg);
      })
    },

    // 重新打分
    onReSetScore(record, indexOld) {
      // 通知所有裁判 将分数置为0
      // console.log(record)
      let that = this,
          index = indexOld + 1
      this.onResetScoreChange(that.scoreList[that.currentIndex], index, 0, that.scoreList[that.currentIndex]['comment' + index])

      // let data = {}
      // let val = that.formatSocketInfo('score_reset', record.num, data)
      // this.socket.send(val)
    },


      scoreCompute(){
        let that = this

        let item  = that.list2[that.currentIndex][that.currentMemberIndex];  
         
          let score_total = 0;
          score_total += parseFloat((item.score_sai>0?item.score_sai:0)*10);
          score_total += parseFloat((item.score_peixun>0?item.score_peixun:0)*10);
          score_total += parseFloat((item.score_gongyi>0?item.score_gongyi:0)*10);


          let score_fanteng =0;
          let score_zhuanti =0;
          let score_tiaoyue =0;
          let score_pingheng =0;
          let score_liliang =0;
          let score_dongzuo =0;
          let score_sudu =0;

          let score_fanteng_kaoguan =0;
          let score_zhuanti_kaoguan =0;
          let score_tiaoyue_kaoguan =0;
          let score_pingheng_kaoguan =0;
          let score_liliang_kaoguan =0;
          let score_dongzuo_kaoguan =0;
          let score_sudu_kaoguan =0;

          that.kaoguan.map((kaoguan,index) =>{
//            if(item['score_fanteng'+(index+1)]>0){
              score_fanteng += parseFloat(item['score_fanteng'+(index+1)])*10;
              score_fanteng_kaoguan ++;
//            }
//            if(item['score_zhuanti'+(index+1)]>0){
              score_zhuanti += parseFloat(item['score_zhuanti'+(index+1)])*10;
              score_zhuanti_kaoguan ++;
//            }
//            if(item['score_tiaoyue'+(index+1)]>0){
              score_tiaoyue += parseFloat(item['score_tiaoyue'+(index+1)])*10;
              score_tiaoyue_kaoguan ++;
//            }
//            if(item['score_pingheng'+(index+1)]>0){
  
              score_pingheng += parseFloat(item['score_pingheng'+(index+1)])*10;
              score_pingheng_kaoguan ++;
//            }
//            if(item['score_liliang'+(index+1)]>0){
              score_liliang += parseFloat(item['score_liliang'+(index+1)])*10;
              score_liliang_kaoguan ++;
//            }
//            if(item['score_dongzuo'+(index+1)]>0){
              score_dongzuo += parseFloat(item['score_dongzuo'+(index+1)])*10;
              score_dongzuo_kaoguan ++;
//            }
//            if(item['score_sudu'+(index+1)]>0){
              score_sudu += parseFloat(item['score_sudu'+(index+1)])*10;
              score_sudu_kaoguan ++;
//            }


          });

          item.score_fanteng=score_fanteng = score_fanteng_kaoguan>0?parseFloat(score_fanteng/score_fanteng_kaoguan):0;
          item.score_zhuanti=score_zhuanti = score_zhuanti_kaoguan>0?parseFloat(score_zhuanti/score_zhuanti_kaoguan):0;
          item.score_tiaoyue=score_tiaoyue = score_tiaoyue_kaoguan>0?parseFloat(score_tiaoyue/score_tiaoyue_kaoguan):0;
          item.score_pingheng=score_pingheng = score_pingheng_kaoguan>0?parseFloat(score_pingheng/score_pingheng_kaoguan):0;
          item.score_liliang=score_liliang = score_liliang_kaoguan>0?parseFloat(score_liliang/score_liliang_kaoguan):0;
          item.score_dongzuo=score_dongzuo = score_dongzuo_kaoguan>0?parseFloat(score_dongzuo/score_dongzuo_kaoguan):0;
          item.score_sudu=score_sudu = score_sudu_kaoguan>0?parseFloat(score_sudu/score_sudu_kaoguan):0;
            console.log('item.score_sudu',item.score_sudu);
            console.log('item.score_dongzuo',item.score_dongzuo);
            console.log('item.score_fanteng',item.score_fanteng);
            console.log('item.score_zhuanti',item.score_zhuanti);
            console.log('item.score_tiaoyue',item.score_tiaoyue);
            console.log('item.score_pingheng',item.score_pingheng);
            console.log('item.score_liliang',item.score_liliang);

        if(this.exameYearType==1){
          score_total +=  score_fanteng+score_zhuanti+score_tiaoyue+score_pingheng+score_liliang+score_dongzuo;
        }else{
          score_total +=  score_fanteng+score_zhuanti+score_tiaoyue+score_pingheng+score_liliang+score_dongzuo+score_sudu;
        }
//                  parseFloat((score_fanteng>0?score_fanteng:0)*10)
//                    +parseFloat((score_zhuanti>0?score_zhuanti:0)*10)
//                    +parseFloat((score_tiaoyue>0?score_tiaoyue:0)*10)
//                    +parseFloat((score_pingheng>0?score_pingheng:0)*10)
//                    +parseFloat((score_liliang>0?score_liliang:0)*10)
//                    +parseFloat((score_dongzuo>0?score_dongzuo:0)*10)

          console.log('item.score_liliang1111',item.score_total);

//          score_total = parseFloat(item.score_sai) + parseFloat(item.score_peixun) + parseFloat(item.score_gongyi);// +parseFloat(score_fanteng);
          item.score_total = score_total/10; 

          that.memberRow = item;
      },


      columnsCompute(){
        if(this.exameYearType==1){ 
          this.step2Columns = [
            {
              title: '运动员姓名',
              dataIndex: 'name',
              width: 200,
              fixed: 'left', 
            },
              {
                title: '参与赛事',
                width: 150,
                dataIndex: 'score_sai',
                scopedSlots: { customRender: 'score_sai' },
              },
              {
                title: '培训课时分',
                width: 150,
                dataIndex: 'score_peixun',
                scopedSlots: { customRender: 'score_peixun' },
              },
              {
                title: '品德',
                width: 150,
                dataIndex: 'score_gongyi',
                scopedSlots: { customRender: 'score_gongyi' },
              },
            {
              title: '翻腾',
              width: 150,
              dataIndex: 'score_fanteng1',
              scopedSlots: { customRender: 'score_fanteng' },
            },
            {
              title: '转体',
              width: 150,
              dataIndex: 'score_zhuanti1',
              scopedSlots: { customRender: 'score_zhuanti' },
            },
            {
              title: '跳跃',
              width: 150,
              dataIndex: 'score_tiaoyue1',
              scopedSlots: { customRender: 'score_tiaoyue' },
            },
            {
              title: '平衡柔韧',
              width: 150,
              dataIndex: 'score_pingheng1',
              scopedSlots: { customRender: 'score_pingheng' },
            },
            {
              title: '力量素质',
              width: 150,
              dataIndex: 'score_liliang1',
              scopedSlots: { customRender: 'score_liliang' },
            },
            {
              title: '动作组合',
              width: 150,
              dataIndex: 'score_dongzuo1',
              scopedSlots: { customRender: 'score_dongzuo' },
            },
            {
              width: 100,
              fixed: 'right',
              title: '总分',
              dataIndex: 'score_total'
            },
          ];
        }else{ 
            this.step2Columns = [
              {
                title: '运动员姓名',
                dataIndex: 'name',
                width: 200,
                fixed: 'left', 
              },
               
              {
                title: '参与赛事',
                width: 150,
                dataIndex: 'score_sai',
                scopedSlots: { customRender: 'score_sai' },
              },
              {
                title: '培训课时分',
                width: 150,
                dataIndex: 'score_peixun',
                scopedSlots: { customRender: 'score_peixun' },
              },
              {
                title: '品德',
                width: 150,
                dataIndex: 'score_gongyi',
                scopedSlots: { customRender: 'score_gongyi' },
              },
              {
                title: '翻腾',
                width: 150,
                dataIndex: 'score_fanteng1',
                scopedSlots: { customRender: 'score_fanteng' },
              },
              {
                title: '转体',
                width: 150,
                dataIndex: 'score_zhuanti1',
                scopedSlots: { customRender: 'score_zhuanti' },
              },
              {
                title: '跳跃',
                width: 150,
                dataIndex: 'score_tiaoyue1',
                scopedSlots: { customRender: 'score_tiaoyue' },
              },
              {
                title: '平衡与柔韧',
                width: 150,
                dataIndex: 'score_pingheng1',
                scopedSlots: { customRender: 'score_pingheng' },
              },
              {
                title: '力量',
                width: 150,
                dataIndex: 'score_liliang1',
                scopedSlots: { customRender: 'score_liliang' },
              },
              {
                title: '动作组合',
                width: 150,
                dataIndex: 'score_dongzuo1',
                scopedSlots: { customRender: 'score_dongzuo' },
              },
              {
                title: '速度与灵敏',
                width: 150,
                dataIndex: 'score_sudu1',
                scopedSlots: { customRender: 'score_sudu' },
              },
              {
                width: 100,
                fixed: 'right',
                title: '总分',
                dataIndex: 'score_total'
              }, 
            ];
        }
      },


      changeMember(index){
        this.currentMemberIndex = index;
        this.scoreCompute();
      },
      changeCurrent(index){
        this.currentMemberIndex = 0;
        this.currentIndex = index;
        this.scoreCompute();
      },
      setHuankao() {
        let that = this  
        setHuankaoStatus({
          id: that.memberRow.baoming_member_id,
          status: that.memberRow.huankao  == 1? 2:1,
        }).then(res => {
          that.$message.success('设置成功')
          that.fetch();
        }).catch(err => {
          that.$message.error(err.data.msg); 
        })

         setSubjectStatus({
        exame_id: that.formData.id,
        list: JSON.stringify(that.list2[this.currentIndex]),
        status:that.memberRow.huankao  == 1 ? 1:3,
      }).then(res => {
        that.$message.success('操作成功'); 
        // 刷新当前状态
        that.fetch()
 
      }).catch(err => {
        console.log('--错误--');
        that.$message.error(err.data.msg);
      })
      },

    handleRank() {
      let that = this
      that.rankVisible = true
      this.columnsCompute()
 
    },
           
  }
}
</script>
